import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import londonEye from '../../asset/images/sights/london-eye.jpg'

import {sights} from '../../asset/sights'

const SightModal = ({ isOpen, toggle, sight }) => {

  const [modalStyles, setModalStyles] = useState({
    zIndex: '1',
  });



  return (
    <Modal className='p-0 modal-lg' style={modalStyles} isOpen={isOpen} toggle={toggle}  centered>
              <ModalBody className='pb-0'>
            {
              sight ?
              <>
              <h4 className='modal-heading'> {sights[sight].title}</h4>
              <div className='row p-3'>
                    <div className='col-md-6 col-12 mt-3 mt-md-0'>
                        <p className='text-primary text-justify'>
                        {sights[sight].text}
                          </p>
                    </div>
                    
                    <div className='col-md-6 col-12 '>
                        <img src={sights[sight].img} className='green-border shadow mt-3 mt-md-0'/>
                    </div>
              </div>
              </>
              :
              <h4>Something went wrong</h4>
            }
              </ModalBody>
      <ModalFooter className='pt-0'>
      <button onClick={toggle} className='btn admin-green-btn'>Close</button>
      </ModalFooter>
    </Modal>
  );
};

export default SightModal;

